import { Backdrop, DialogContentText, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import loader from "../../../assets/loaderAnimation.json";
import Lottie from "lottie-react";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles<Theme, LoaderProps>((theme) => ({
  newPosOfDialog: {
    padding: 16,
    maxWidth: 328,
    minHeight: 263,
    backgroundColor: "#FFFFFF",
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: 15,
  },
  loaderAnimation: {
    width: "200px",
    height: "167px",
  },
}));

interface LoaderProps {
  open: boolean;
  message: string;
}

export const LoaderDialog = (props: LoaderProps) => {
  const classes = useStyles(props);
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.open}>
      <Dialog
        fullWidth
        maxWidth="md"
        classes={{
          paper: classes.newPosOfDialog,
        }}
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <Stack direction={"column"} alignItems={"center"}>
          <Lottie
            className={classes.loaderAnimation}
            animationData={loader}
            loop={true}
          />
          <DialogContentText id="alert-dialog-description">
            {props.message}
          </DialogContentText>
        </Stack>
      </Dialog>
    </Backdrop>
  );
};
